import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useCustomToast } from 'design-system';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'api/v1/cms/exclusive-deals';
export const updateExclusiveDealEndpointIdentifier = endpoint;

interface BodyType {
  cashbackPercent?: number | null;
  isActive?: boolean;
  dealPrice?: number;
  // Ladder rung the price is agreed against; absent = unchanged.
  dealUnit?: 'PACK' | 'ITEM' | 'BASE';
  productExpiryDate?: string | null;
  isNearExpiry?: boolean;
}

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  dealId: number;
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useUpdateExclusiveDealApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ dealId, body }: TVariables) => {
    try {
      const { data } = await http.put(endpoint + `/${dealId}`, body);

      toast({
        description: 'Exclusive deal has been updated successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
